import { render, staticRenderFns } from "./policyReceived.vue?vue&type=template&id=d6ecd10e&scoped=true&"
import script from "./policyReceived.vue?vue&type=script&lang=js&"
export * from "./policyReceived.vue?vue&type=script&lang=js&"
import style0 from "./policyReceived.vue?vue&type=style&index=0&id=d6ecd10e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ecd10e",
  null
  
)

export default component.exports